import { SiteNavAnalytics } from '../../lib/helpers/SiteNavAnalytics'
import { NavAnalyticsType } from '../../types/NavAnalytics.type'

/**
 * Returns Nav for clicks on the tier1 anchor, otherwise return NavTray
 */
export function getNavType(el: HTMLElement): NavAnalyticsType {
  const isTier1AnchorClick = !!el.closest('li.AppMenu-tier1MenuItem > a')
  return isTier1AnchorClick ? NavAnalyticsType.Nav : NavAnalyticsType.NavTray
}

const isExpandableClick = (el: HTMLElement) => !!el.closest('.is-expandable')

export const shouldSuppressMenuPing = (target: HTMLElement): boolean => {
  return isExpandableClick(target)
}

export const resolveMenuMessage = (target: HTMLElement): string => {
  const direct = target.getAttribute('data-analytics')
  if (direct) return direct

  const closestWithAttr = target.closest(
    '[data-analytics]'
  ) as HTMLElement | null
  if (closestWithAttr) {
    const v = closestWithAttr.getAttribute('data-analytics')
    if (v) return v
  }

  const text = (target as HTMLAnchorElement).textContent?.trim()
  return text || ''
}

export const resolveHeaderMessage = (target: HTMLElement): string =>
  (target as HTMLAnchorElement).innerText?.trim() || ''

const safePing = (
  analytics: SiteNavAnalytics,
  message: string,
  type: NavAnalyticsType
) => {
  try {
    if (typeof message !== 'string' || message.trim().length === 0) {
      return
    }
    analytics.ping(message, type)
  } catch {
    console.error('analytics.ping failed')
  }
}

export function createSiteNavAnalyticsClickHandlers(opts?: {
  siteNavAnalytics?: SiteNavAnalytics
}) {
  const analytics = opts?.siteNavAnalytics ?? new SiteNavAnalytics()

  const handleHeaderClick = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    const target = e.currentTarget as HTMLElement
    const message = resolveHeaderMessage(target)
    safePing(analytics, message, NavAnalyticsType.Header)
  }

  const handleMenuClick = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    const target = e.currentTarget as HTMLElement
    const type = getNavType(target) // 'nav' | 'navtray'
    if (shouldSuppressMenuPing(target)) {
      return
    }
    const message = resolveMenuMessage(target)
    safePing(analytics, message, type)
  }

  const handleBreadcrumbClick = (
    e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
  ) => {
    const target = e.currentTarget as HTMLElement
    const message = resolveMenuMessage(target)
    safePing(analytics, message, NavAnalyticsType.Breadcrumb)
  }

  return { handleHeaderClick, handleMenuClick, handleBreadcrumbClick }
}
